import styles from './DashboardPlaceholder.module.scss';

interface DashboardPlaceholderProps {
  title: string;
}

const DashboardPlaceholder = ({ title }: DashboardPlaceholderProps) => {
  return (
    <div className={styles.wrapper}>
      <h1>{title}</h1>
    </div>
  );
};

export default DashboardPlaceholder;
